import styled, { CSSProperties } from 'styled-components';
import { measures } from '../../theme/measures';

interface Props {
  bgColor?: CSSProperties['backgroundColor'];
  relative?: boolean;
}

export const Viewport = styled.div<Props>`
  height: ${measures.viewportHeight};
  overflow: auto;
  flex: 1;
  width: 100%;
  background-color: ${({ bgColor }) => bgColor || '#fff'};
  position: ${({ relative }) => (relative ? 'relative' : 'static')};
`;
